import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import SegmentCard, { ButtonRow } from '../SegmentCard/SegmentCard';
import { Button } from 'merchant-portal-components';
import QueryBuilder from './QueryBuilder/QueryBuilder';
import { SmallToggleSwitch } from '../../../../components/ToggleSwitch/ToggleSwitch';
import { BoldCapitalizedLabel } from 'merchant-portal-components';
import FilterButton from '../../../../components/FilterModal/FilterButton';
import LocationFilterModal from '../../../../components/FilterModal/LocationFilterModal';

const ErrorMessage = styled.div`
  color: red;
  margin-left: 15px;
`;

const SelectWrapper = styled.div`
  display: grid;
  grid-gap: 50px;
  margin-bottom: 20px;
  width: 80%;
`;

const Wrapper = styled.div``;

class FilterCriteria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emptyFieldsError: false,
      isChecked: this.props.businesses.length === 0,
      isOpen: false,
    };
    this.nextPage = this.nextPage.bind(this);
  }

  validateEmptyFields() {
    let emptyFieldsError = false;

    const iterateGroupRules = (rules) => {
      return Object.keys(rules).map((rule, index) => {
        if (
          Object.keys(this.props.criteria.filter_json.children1).length === 1 &&
          !rules[rule].properties.field
        ) {
          this.nextPage();
        }
        if (rules[rule].type === 'group') {
          iterateGroupRules(rules[rule].children1);
        } else if (
          rules[rule].properties.value == false &&
          rules[rule].properties.value != '0'
        ) {
          emptyFieldsError = true;
        }
        if (index === Object.keys(rules).length - 1) {
          this.setState({ emptyFieldsError }, () => this.nextPage());
        }
      });
    };

    if (this.props.criteria) {
      const rules = this.props.criteria.filter_json.children1;
      iterateGroupRules(rules);
    } else {
      this.nextPage();
    }
  }

  nextPage() {
    if (!this.state.emptyFieldsError) {
      this.props.fetchTargetAudienceData(
        this.props.audience,
        this.props.criteria
      );
      this.props.onSubmit();
    }
  }
  handleOpenFilterLocationModal = (isOpen) => {
    this.setState({ isOpen });
  };
  handleSelecteAll(checked) {
    if (checked) {
      const allBusinessesIDs = this.props.businessLocationsOfMerchant.map(
        (business) => business.id
      );
      this.props.change('businesses', allBusinessesIDs);
    } else {
      this.props.change('businesses', []);
    }
  }
  render() {
    const title = 'filter criteria';
    const { isOpen } = this.state;
    const instructions = (
      <div>
        A <em>Group</em> is a collection of app users, categorized by their
        purchase history such as transaction dates, points earned, total
        transactions made, etc. A <em>Group</em> is the basis for building a
        targeted audience. <em>Groups</em> are made of <em>Rules</em> that
        dictate the parameters of the
        <em>Group</em>. All <em>Groups</em> must have at least one <em>Rule</em>
        . <br />
        <br />
        You may add more <em>Rules</em> to a <em>Group</em> or add more{' '}
        <em>Groups</em> to further customise any Segment based on provided
        criteria.
      </div>
    );
    return (
      <SegmentCard
        title={title}
        instructions={instructions}
        cancelEditSegment={this.props.cancelEditSegment}
      >
        <div>
          <QueryBuilder
            updateCriteria={this.props.updateCriteria}
            criteria={this.props.criteria}
            allTags={this.props.allTags}
            allProducts={this.props.allProducts}
            appConfiguration={this.props.appConfiguration}
          />
          {this.state.emptyFieldsError && (
            <ErrorMessage>Fill out blank field(s).</ErrorMessage>
          )}
        </div>
        <div style={{ width: '50%' }}>
          <BoldCapitalizedLabel>Choose Targeted Locations</BoldCapitalizedLabel>
          <Wrapper>
            <div style={{ margin: '10px 0 15px 0' }}>
              <SmallToggleSwitch
                checked={
                  this.props.businesses.length === this.props.totalBusinessQty
                }
                label='All Locations'
                onChange={(e) => this.handleSelecteAll(e.target.checked)}
              />
            </div>
            <FilterButton
              message={
                this.props.totalBusinessQty === this.props.businesses.length
                  ? 'All Locations selected'
                  : this.props.businesses.length === 0
                  ? 'No location is selected'
                  : `Selected Locations (${this.props.businesses.length})`
              }
              height='55px'
              setIsOpen={this.handleOpenFilterLocationModal}
            />

            <LocationFilterModal
              placeholder='Enter Internal Location Name'
              searchLabel='Search by Internal Location Name'
              filteredLocations={this.props.businesses}
              setFilteredLocations={this.props.change}
              isOpen={isOpen}
              setIsOpen={this.handleOpenFilterLocationModal}
              formField='businesses'
              emptyIsEqualToAll={false}
              isEmptyAccepted={true}
            />
          </Wrapper>
        </div>

        <ButtonRow>
          <Button
            type='button'
            onClick={() => this.props.previousPage()}
            secondary
          >
            Back
          </Button>

          <Button type='button' onClick={() => this.validateEmptyFields()}>
            Next
          </Button>
        </ButtonRow>
      </SegmentCard>
    );
  }
}

const mapStateToProps = (state) => ({
  totalBusinessQty:
    state.businessLocationsList.businessLocationsOfMerchant.length,
  businessLocationsOfMerchant:
    state.businessLocationsList.businessLocationsOfMerchant,
  appConfiguration: state.accountReducer.appMetaData.configuration,
});

export default connect(mapStateToProps)(FilterCriteria);
